var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.competitionType === 1)?_c('SchoolAdminLayout'):(_vm.competitionType === 2)?_c('TrainAdminLayout'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }